import { createContext } from 'react';
import { noop } from "../../utils/noop";
var defaultFlipContext = {
  registerChild: noop,
  unregisterChild: noop,
  registeredChildren: null
};
export var FlipContext = createContext(defaultFlipContext);